import { render, staticRenderFns } from "./Additional.vue?vue&type=template&id=42cf4d76&scoped=true&"
import script from "./Additional.vue?vue&type=script&lang=js&"
export * from "./Additional.vue?vue&type=script&lang=js&"
import style0 from "./Additional.vue?vue&type=style&index=0&id=42cf4d76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cf4d76",
  null
  
)

export default component.exports